import { Route, Routes } from "react-router-dom";
import { Justification } from "./list";

export default function JustificationRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Justification />} />
      <Route path="/edit" element={<p>Editar Justificaçãoes</p>} />
    </Routes>
  );
}
